import FileService from '@/services/file.service'

const fileServiceMixin = {
  data () {
    return {
      fileService: FileService
    }
  },

  created () {
    if (typeof this.fileService === 'function') {
      // eslint-disable-next-line
      this.fileService = new this.fileService()
    }
  }
}

export default fileServiceMixin
